/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IDRequestMetadata } from './IDRequestMetadata';
import {
    IDRequestMetadataFromJSON,
    IDRequestMetadataFromJSONTyped,
    IDRequestMetadataToJSON,
} from './IDRequestMetadata';

/**
 * 
 * @export
 * @interface PostTokenRequestV2
 */
export interface PostTokenRequestV2 {
    /**
     * 
     * @type {IDRequestMetadata}
     * @memberof PostTokenRequestV2
     */
    metadata: IDRequestMetadata;
}

/**
 * Check if a given object implements the PostTokenRequestV2 interface.
 */
export function instanceOfPostTokenRequestV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metadata" in value;

    return isInstance;
}

export function PostTokenRequestV2FromJSON(json: any): PostTokenRequestV2 {
    return PostTokenRequestV2FromJSONTyped(json, false);
}

export function PostTokenRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PostTokenRequestV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metadata': IDRequestMetadataFromJSON(json['metadata']),
    };
}

export function PostTokenRequestV2ToJSON(value?: PostTokenRequestV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metadata': IDRequestMetadataToJSON(value.metadata),
    };
}

